export interface ComicChapter {
  id: string;
  title: string;
  number: number;
  updatedAt: string;
}

export interface Comic {
  id: string;
  slug: string;
  title: string;
  author: string;
  coverImage: string;
  coverImageColor: string;
  description: string;
  descriptionHtml: string;
  category: string;
  categorySlug: string;
  tags: string[];
  rating: number;
  reads: number;
  totalChapters: number;
  updateFrequency: string;
  status: string;
  chapters: ComicChapter[];
  featured?: boolean;
  isHot?: boolean;
  isNew?: boolean;
}

export const comics: Comic[] = [
  {
    id: 'comic-1',
    slug: 'dongdong-zahuopu',
    title: '洞洞杂货铺',
    author: '七月',
    coverImage: 'https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20a%20mysterious%20curio%20shop%20interior%20with%20warm%20amber%20lighting%2C%20wooden%20shelves%20filled%20with%20magical%20trinkets%20and%20oddities%2C%20a%20young%20shopkeeper%20character%20standing%20in%20the%20center%2C%20soft%20glowing%20lanterns%2C%20fantasy%20slice-of-life%20aesthetic%2C%20detailed%20watercolor-inspired%20art%20style%2C%20cozy%20atmosphere%2C%20gentle%20warm%20color%20palette%20with%20golden%20accents&width=600&height=800&seq=comic-cover-01&orientation=portrait',
    coverImageColor: 'amber',
    description: '在一座不起眼的小镇角落，有一家神秘的杂货铺。店铺的主人是个看起来不过二十岁的青年，但据说他已经在这里经营了上百年。每一个走进杂货铺的客人，都能买到他们真正需要，却从未见过的东西……',
    descriptionHtml: '<p>在一座不起眼的小镇角落，有一家神秘的杂货铺。店铺的主人是个看起来不过二十岁的青年，但据说他已经在这里经营了上百年。每一个走进杂货铺的客人，都能买到他们真正需要，却从未见过的东西……</p><p>这里有能让人看到过去的镜子，有能装下整个夏天的玻璃瓶，还有会说话的猫咪店员。每一个物品背后，都藏着一个温暖而奇幻的故事。</p>',
    category: '治愈',
    categorySlug: 'healing',
    tags: ['奇幻', '治愈', '日常', '暖心'],
    rating: 9.7,
    reads: 12800000,
    totalChapters: 156,
    updateFrequency: '每周三更新',
    status: '连载中',
    featured: true,
    isHot: true,
    chapters: [
      { id: 'ch-1', title: '第1话 会说话的猫', number: 1, updatedAt: '2026-01-15' },
      { id: 'ch-2', title: '第2话 夏天的玻璃瓶', number: 2, updatedAt: '2026-01-22' },
      { id: 'ch-3', title: '第3话 记忆之镜', number: 3, updatedAt: '2026-01-29' },
      { id: 'ch-4', title: '第4话 时间沙漏', number: 4, updatedAt: '2026-02-05' },
      { id: 'ch-5', title: '第5话 月光收集器', number: 5, updatedAt: '2026-02-12' },
      { id: 'ch-32', title: '第32话 重逢', number: 32, updatedAt: '2026-07-01' },
    ],
  },
  {
    id: 'comic-2',
    slug: 'xingkong-wangzi',
    title: '星空王子',
    author: '林小夏',
    coverImage: 'https://readdy.ai/api/search-image?query=Romantic%20anime%20illustration%20of%20a%20young%20prince%20character%20under%20a%20starry%20night%20sky%2C%20flowing%20cape%2C%20dreamy%20expression%2C%20constellations%20visible%20in%20the%20background%2C%20soft%20pink%20and%20lavender%20color%20palette%2C%20shoujo%20manga%20art%20style%2C%20gentle%20atmosphere%2C%20twinkling%20stars%2C%20minimalist%20composition&width=600&height=800&seq=comic-cover-02&orientation=portrait',
    coverImageColor: 'rose',
    description: '高中生小悠在某个夜晚意外遇见来自星空的神秘少年。他说自己是一位王子，来自人类无法看见的星辰国度。一段跨越星际的浪漫冒险就此展开……',
    descriptionHtml: '<p>高中生小悠在某个夜晚意外遇见来自星空的神秘少年。他说自己是一位王子，来自人类无法看见的星辰国度。一段跨越星际的浪漫冒险就此展开……</p>',
    category: '恋爱',
    categorySlug: 'romance',
    tags: ['恋爱', '奇幻', '校园', '少女'],
    rating: 9.5,
    reads: 9800000,
    totalChapters: 89,
    updateFrequency: '每周五更新',
    status: '连载中',
    isHot: true,
    chapters: [
      { id: 'ch2-1', title: '第1话 星空下的邂逅', number: 1, updatedAt: '2026-02-10' },
      { id: 'ch2-2', title: '第2话 星辰国的秘密', number: 2, updatedAt: '2026-02-17' },
      { id: 'ch2-3', title: '第3话 月光舞会', number: 3, updatedAt: '2026-02-24' },
    ],
  },
  {
    id: 'comic-3',
    slug: 'jiansheng-chuanshuo',
    title: '剑圣传说',
    author: '大风堂',
    coverImage: 'https://readdy.ai/api/search-image?query=Dynamic%20action%20anime%20illustration%20of%20a%20swordsman%20in%20traditional%20martial%20arts%20robe%2C%20holding%20a%20glowing%20sword%2C%20dramatic%20wind%20effects%2C%20mountain%20peak%20background%2C%20misty%20atmosphere%2C%20epic%20fantasy%20wuxia%20style%2C%20bold%20brushstroke%20art%2C%20green%20and%20gold%20color%20accents%2C%20powerful%20composition&width=600&height=800&seq=comic-cover-03&orientation=portrait',
    coverImageColor: 'mint',
    description: '少年剑客叶凌云，自幼在深山修炼，十六岁那年，他带着师父的遗命下山，踏入了一个强者为尊的江湖世界。一剑在手，天下我有！',
    descriptionHtml: '<p>少年剑客叶凌云，自幼在深山修炼，十六岁那年，他带着师父的遗命下山，踏入了一个强者为尊的江湖世界。一剑在手，天下我有！</p>',
    category: '热血',
    categorySlug: 'action',
    tags: ['热血', '武侠', '战斗', '冒险'],
    rating: 9.6,
    reads: 15600000,
    totalChapters: 203,
    updateFrequency: '每周一、四更新',
    status: '连载中',
    isHot: true,
    chapters: [
      { id: 'ch3-1', title: '第1话 下山', number: 1, updatedAt: '2026-01-05' },
      { id: 'ch3-2', title: '第2话 初入江湖', number: 2, updatedAt: '2026-01-08' },
      { id: 'ch3-3', title: '第3话 第一战', number: 3, updatedAt: '2026-01-12' },
    ],
  },
  {
    id: 'comic-4',
    slug: 'anye-zhuizong',
    title: '暗夜追踪',
    author: '墨白',
    coverImage: 'https://readdy.ai/api/search-image?query=Noir%20mystery%20anime%20illustration%20of%20a%20detective%20character%20in%20a%20dark%20alleyway%2C%20trench%20coat%2C%20moody%20streetlamp%20lighting%2C%20rain-slicked%20pavement%2C%20suspenseful%20atmosphere%2C%20cool%20gray%20and%20deep%20navy%20color%20palette%2C%20cinematic%20composition%2C%20seinen%20manga%20style%2C%20mysterious%20shadow%20figure%20in%20distance&width=600&height=800&seq=comic-cover-04&orientation=portrait',
    coverImageColor: 'gray',
    description: '刑警队长林深在一起连环案件中发现了不寻常的线索。每一个受害者身上都有一个奇怪的符号，指向一个隐藏在城市暗处的神秘组织……',
    descriptionHtml: '<p>刑警队长林深在一起连环案件中发现了不寻常的线索。每一个受害者身上都有一个奇怪的符号，指向一个隐藏在城市暗处的神秘组织……</p>',
    category: '悬疑',
    categorySlug: 'mystery',
    tags: ['悬疑', '推理', '犯罪', '都市'],
    rating: 9.4,
    reads: 7200000,
    totalChapters: 67,
    updateFrequency: '每周六更新',
    status: '连载中',
    chapters: [
      { id: 'ch4-1', title: '第1话 第一具尸体', number: 1, updatedAt: '2026-03-01' },
      { id: 'ch4-2', title: '第2话 符号之谜', number: 2, updatedAt: '2026-03-08' },
    ],
  },
  {
    id: 'comic-5',
    slug: 'maoxian-wangguo',
    title: '猫仙王国',
    author: '喵小白',
    coverImage: 'https://readdy.ai/api/search-image?query=Cute%20anime%20illustration%20of%20magical%20cats%20in%20a%20whimsical%20kingdom%2C%20fluffy%20cat%20characters%20wearing%20tiny%20crowns%2C%20colorful%20mushroom%20houses%2C%20pastel%20color%20palette%2C%20soft%20warm%20lighting%2C%20kawaii%20art%20style%2C%20fantasy%20slice-of-life%2C%20sparkles%20and%20magic%20effects%2C%20cozy%20vibe&width=600&height=800&seq=comic-cover-05&orientation=portrait',
    coverImageColor: 'warm',
    description: '小女孩朵朵在自家后院发现了一个通往猫仙王国的秘密入口。在这个神奇的王国里，猫咪们会说话、会魔法，还经营着各种有趣的小店！',
    descriptionHtml: '<p>小女孩朵朵在自家后院发现了一个通往猫仙王国的秘密入口。在这个神奇的王国里，猫咪们会说话、会魔法，还经营着各种有趣的小店！</p>',
    category: '治愈',
    categorySlug: 'healing',
    tags: ['治愈', '奇幻', '萌系', '日常'],
    rating: 9.3,
    reads: 5600000,
    totalChapters: 45,
    updateFrequency: '每周日更新',
    status: '连载中',
    isNew: true,
    chapters: [
      { id: 'ch5-1', title: '第1话 后院的秘密', number: 1, updatedAt: '2026-05-10' },
      { id: 'ch5-2', title: '第2话 猫咪咖啡馆', number: 2, updatedAt: '2026-05-17' },
    ],
  },
  {
    id: 'comic-6',
    slug: 'shikong-lieche',
    title: '时空列车',
    author: '南宫逸',
    coverImage: 'https://readdy.ai/api/search-image?query=Steampunk%20anime%20illustration%20of%20a%20mysterious%20train%20traveling%20through%20time%2C%20clockwork%20gears%20and%20pocket%20watches%20floating%20around%2C%20young%20protagonist%20looking%20out%20the%20window%20at%20different%20time%20periods%2C%20warm%20brass%20and%20copper%20tones%2C%20retro-futuristic%20vibe%2C%20detailed%20mechanical%20elements%2C%20adventure%20atmosphere&width=600&height=800&seq=comic-cover-06&orientation=portrait',
    coverImageColor: 'brass',
    description: '在一个平凡的站台，一列不该出现的列车缓缓驶来。每个登上这辆列车的人，都将被带往他们命中注定要去的时空——过去，或者未来。',
    descriptionHtml: '<p>在一个平凡的站台，一列不该出现的列车缓缓驶来。每个登上这辆列车的人，都将被带往他们命中注定要去的时空——过去，或者未来。</p>',
    category: '悬疑',
    categorySlug: 'mystery',
    tags: ['悬疑', '科幻', '时空', '冒险'],
    rating: 9.2,
    reads: 4100000,
    totalChapters: 34,
    updateFrequency: '每两周更新',
    status: '连载中',
    isNew: true,
    chapters: [
      { id: 'ch6-1', title: '第1话 末班车', number: 1, updatedAt: '2026-06-01' },
      { id: 'ch6-2', title: '第2话 民国站台', number: 2, updatedAt: '2026-06-15' },
    ],
  },
  {
    id: 'comic-7',
    slug: 'yongzhe-tuan',
    title: '勇者团',
    author: '战斧工作室',
    coverImage: 'https://readdy.ai/api/search-image?query=Epic%20fantasy%20anime%20illustration%20of%20a%20party%20of%20adventurers%2C%20warrior%20knight%20mage%20and%20rogue%20characters%20standing%20together%2C%20dragon%20silhouette%20in%20distant%20sky%2C%20medieval%20fantasy%20setting%2C%20vibrant%20mint%20green%20and%20gold%20accents%2C%20action-oriented%20composition%2C%20detailed%20armor%20designs%2C%20heroic%20atmosphere&width=600&height=800&seq=comic-cover-07&orientation=portrait',
    coverImageColor: 'mint',
    description: '魔王降临，世界陷入危机。五位来自不同种族的年轻人被命运选中，组成勇者团，踏上了讨伐魔王的冒险之旅。但真正的敌人，或许并非魔王……',
    descriptionHtml: '<p>魔王降临，世界陷入危机。五位来自不同种族的年轻人被命运选中，组成勇者团，踏上了讨伐魔王的冒险之旅。但真正的敌人，或许并非魔王……</p>',
    category: '热血',
    categorySlug: 'action',
    tags: ['热血', '冒险', '奇幻', '团队'],
    rating: 9.5,
    reads: 8900000,
    totalChapters: 112,
    updateFrequency: '每周二更新',
    status: '连载中',
    isHot: true,
    chapters: [
      { id: 'ch7-1', title: '第1话 命运之日', number: 1, updatedAt: '2026-02-01' },
      { id: 'ch7-2', title: '第2话 集结', number: 2, updatedAt: '2026-02-08' },
    ],
  },
  {
    id: 'comic-8',
    slug: 'yinghua-jie',
    title: '樱花街',
    author: '春日暖',
    coverImage: 'https://readdy.ai/api/search-image?query=Romantic%20anime%20illustration%20of%20a%20cherry%20blossom-lined%20street%20in%20spring%2C%20two%20high%20school%20characters%20walking%20together%20under%20falling%20petals%2C%20soft%20pink%20and%20cream%20color%20palette%2C%20gentle%20sunlight%20filtering%20through%20trees%2C%20shoujo%20manga%20aesthetic%2C%20warm%20nostalgic%20atmosphere%2C%20simple%20clean%20composition&width=600&height=800&seq=comic-cover-08&orientation=portrait',
    coverImageColor: 'rose',
    description: '樱花街99号，有一家小小的甜品店。店长是个温柔的女孩，每一位来店的客人，都会得到一份特别的甜品——一份能唤起美好回忆的甜品。',
    descriptionHtml: '<p>樱花街99号，有一家小小的甜品店。店长是个温柔的女孩，每一位来店的客人，都会得到一份特别的甜品——一份能唤起美好回忆的甜品。</p>',
    category: '恋爱',
    categorySlug: 'romance',
    tags: ['恋爱', '治愈', '日常', '美食'],
    rating: 9.1,
    reads: 3400000,
    totalChapters: 28,
    updateFrequency: '每月更新',
    status: '连载中',
    isNew: true,
    chapters: [
      { id: 'ch8-1', title: '第1话 草莓蛋糕', number: 1, updatedAt: '2026-06-10' },
      { id: 'ch8-2', title: '第2话 抹茶拿铁', number: 2, updatedAt: '2026-06-17' },
    ],
  },
];

export function getComicBySlug(slug: string): Comic | undefined {
  return comics.find((c) => c.slug === slug);
}

export function getComicsByCategory(categorySlug: string): Comic[] {
  return comics.filter((c) => c.categorySlug === categorySlug);
}

export function getHotComics(): Comic[] {
  return comics.filter((c) => c.isHot);
}

export function getNewComics(): Comic[] {
  return comics.filter((c) => c.isNew);
}

export function getFeaturedComic(): Comic | undefined {
  return comics.find((c) => c.featured);
}